import React from 'react';
import { isNumber } from '~utils/validators';
import {
  Block,
  Input as StyledInput,
  IconWrapper,
  viewStyles,
} from './styledComponents';

const masks = {
  number: isNumber,
};

//todo: type inputProps with JSX.IntrinsicElements['input'], there is styled components ref error
export type Props<NameType extends string> = {
  name: NameType;
  value: string;
  onChange: (name: NameType, value: string) => void;
  onBlur: (name: NameType, value: string) => void;
  hasError?: boolean;
  viewStyle?: keyof typeof viewStyles;
  borderColor?: string;
  iconElement?: React.ReactNode;
  mask?: keyof typeof masks;
  className?: string;
  tabIndex?: number;
  placeholder?: string;
};

const Input = <NameType extends string>({
  hasError,
  borderColor,
  iconElement,
  className,
  onChange,
  onBlur,
  mask,
  name,
  placeholder,
  tabIndex = 0,
  value,
  viewStyle = 'white',
  ...inputProps
}: Props<NameType>) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = e;

    if (mask) {
      const validatorFn = masks[mask];
      const isValueValid = validatorFn(value);
      if (!isValueValid) return;
    }

    onChange(name, value);
  };

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    onBlur(name, e.target.value);
  };

  return (
    <Block
      className={className}
      borderColor={borderColor}
      hasError={hasError}
      viewStyle={viewStyle}
    >
      <StyledInput
        name={name}
        tabIndex={tabIndex}
        viewStyle={viewStyle}
        hasError={hasError}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        value={value}
        {...inputProps}
      />
      {iconElement && <IconWrapper>{iconElement}</IconWrapper>}
    </Block>
  );
};

export default Input;
